(() => {
  const swatch_title = document.querySelector(".swatch-title__color");
  let swatch_timer;
  document
    .querySelectorAll(
      ".custom-swatches-main .swatches-wrapper .swatch-container"
    )
    .forEach((swatch) => {
      swatch.addEventListener("mouseenter", (e) => {
        clearTimeout(swatch_timer);
        swatch_title.innerText = e.currentTarget
          .querySelector(".swatch-hover-title")
          .innerText.trim();
      });
      swatch.addEventListener("mouseleave", (e) => {
        swatch_timer = setTimeout(() => {
          swatch_title.innerText = swatch_title.dataset.color;
        }, 300);
      });
    });
})();
